export default __webpack_public_path__ + "static/media/Rectangle 5906.fcd88f6e.png";